import axios from 'axios';

const BASE = '/api/integrations/leads';

// Providers
export const fetchLeadProviders = () => axios.get(`${BASE}/providers`);
export const fetchLeadProvider = (id) => axios.get(`${BASE}/providers/${id}`);
export const createLeadProvider = (body) => axios.post(`${BASE}/providers`, body);
export const updateLeadProvider = (id, body) => axios.put(`${BASE}/providers/${id}`, body);
export const removeLeadProvider = (id) => axios.delete(`${BASE}/providers/${id}`);

// Mappings
export const fetchLeadMappings = (providerId) =>
	axios.get(`${BASE}/providers/${providerId}/mappings`);
export const createLeadMapping = (providerId, body) =>
	axios.post(`${BASE}/providers/${providerId}/mappings`, body);
export const updateLeadMapping = (id, body) => axios.put(`${BASE}/mappings/${id}`, body);
export const removeLeadMapping = (id) => axios.delete(`${BASE}/mappings/${id}`);

// Aliases
export const fetchLeadAliases = (source) => axios.get(`${BASE}/aliases/${source}`);
export const createLeadAlias = (body) => axios.post(`${BASE}/aliases`, body);
export const removeLeadAlias = (id) => axios.delete(`${BASE}/aliases/${id}`);

// Mailboxes
export const fetchLeadMailboxes = () => axios.get(`${BASE}/mailboxes`);
export const createLeadMailbox = (body) => axios.post(`${BASE}/mailboxes`, body);
export const updateLeadMailbox = (id, body) => axios.put(`${BASE}/mailboxes/${id}`, body);
export const removeLeadMailbox = (id) => axios.delete(`${BASE}/mailboxes/${id}`);
export const fetchLeadMailboxMessages = (id, params) =>
	axios.get(`${BASE}/mailboxes/${id}/messages`, { params });
export const parseLeadMailboxMessages = (id, body) => axios.post(`${BASE}/mailboxes/${id}/parse`, body);

// Subscriptions
export const fetchLeadSubscriptions = () => axios.get(`${BASE}/subscriptions`);
export const ensureLeadSubscriptions = () => axios.post(`${BASE}/subscriptions/ensure`);
export const removeLeadSubscription = (id) => axios.delete(`${BASE}/subscriptions/${id}`);

// Monitor / processed
export const fetchLeadProcessed = (params) => axios.get(`${BASE}/processed`, { params });
export const replayLeadProcessed = (id) => axios.post(`${BASE}/processed/${id}/replay`);
